import { Stack, Typography, colors } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { useMemo } from "react";
import { useMatchHints } from "../../hooks/enigmaStats.hooks";
import { formatPercentage } from "../../libs/gameAnalysis/utils";
import { MatchFilter } from "../../libs/statsFilters";

export type EnigmaHintsDistributionProps = {
  enigmaId?: string;
  cityEscapeId?: string | null;
  isLoading?: boolean;
  filters?: MatchFilter;
};

export function EnigmaHintsDistribution({
  enigmaId,
  cityEscapeId,
  isLoading,
  filters,
}: EnigmaHintsDistributionProps) {
  const matchHints = useMatchHints(cityEscapeId, enigmaId, filters);

  const totalMatchHints = useMemo(() => {
    if (matchHints.data) {
      return Object.entries(matchHints.data).reduce(
        (sum, [, value]) => sum + value,
        0
      );
    }
    return 0;
  }, [matchHints.data]);

  return (
    <Stack direction="column" flexGrow={1}>
      <Typography variant="caption" gutterBottom>
        Ispirazioni chieste
      </Typography>
      <PieChart
        loading={isLoading}
        series={[
          {
            data: Object.entries(matchHints.data ?? {}).map(([key, value]) => {
              // console.debug("Hints per match:", key, value);
              const hintNo = parseInt(key);
              let color: string = colors.lightBlue[100];
              if (hintNo > 0) {
                let colours = [colors.yellow, colors.orange];
                const colorIndex: any = Math.floor(hintNo / 5);
                const shadeIndex: number = hintNo % 4;
                const shadeKey: any = shadeIndex === 0 ? 200 : shadeIndex * 200;
                const colour =
                  colours[colorIndex] ?? colours[colours.length - 1];

                color = colour[shadeKey as keyof typeof colour];
              }

              return {
                id: key,
                value,
                label: `${key}° Ispirazione`,
                color,
              };
            }),
            innerRadius: 30,
            outerRadius: 100,
            paddingAngle: 5,
            cornerRadius: 5,
            valueFormatter: (item: any) =>
              `${formatPercentage(item.value, totalMatchHints)}`,
          },
        ]}
        width={200}
        height={200}
      />
    </Stack>
  );
}
